// Note: this should be a file (and possibly a library) shared equally between the two apps,
// not located in `application`.
// Ideally the build would support that; for now we won't bother.

import { Database, defaultSchema } from '@nutrien/ddc-fe-logging-pwa';

import appConfig from '../../config/app.config.json';

export const schema = defaultSchema;

export type DemoSchema = typeof schema;

export const database: Database<DemoSchema> = {
  name: appConfig.appName,
  schema,
  version: 1,
};
